export interface WinConfig {
    normal: WinType;
    turbo: WinType;
}

export interface WinType {
    winTypes: WinTypeConfig[];
    initial: {
        animation: WinConfigAnimation[];
        time: number;
    };
    collapse?: {
        animation: WinConfigAnimation[];
        time: number;
    };
    regular: {
        pattern: string[];
        animation: WinConfigAnimation[];
        time: number;
    }[];
}

export interface WinConfigAnimation {
    symbol: string;
    spine?: string;
    animation: string;
    skinName?: string;
    langSkins?: {
        [lang: string]: string;
    };
    cached?: boolean;
    hit?: string;
    static?: string;
}

export interface WinTypeConfig {
    minWinToBetRatio: number;
    maxWinToBetRatio?: number;
    name: string;
    sounds?: string[];
    duration?: number;
    noCountUpAnimation?: boolean;
}